<template>
    <div>
        <Report :allKip='allChildKp'
                v-if="isshow"
                :iserrorknow='errorknow'></Report>
        <!--<div v-if="!isshow"
             class="loadClass">
            <img src="../../assets/img/detail/gif_loading_gray.gif" />
            <p>正在加载...</p>
        </div>-->
    </div>
</template>
    
<script>
import Report from '@/components/details/report'
export default {
    components: { Report },
    data: function () {
        return {
            sectionCode: this.$route.params.sectionCode,
            allChildKp: '',
            isshow: false,
            errorknow: '知识点'
        }
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm => {
            window.scrollTo(0, 0)
        })
    },
    mounted: function () {
        this.$http.post('/zy/m/s/report/learning2/sectionDetail', {}, {
            params: { sectionCode: this.sectionCode }
        }).then((res) => {
            // success callback
            this.allChildKp = res.data.ret
            this.isshow = true
        }, (response) => {
            // error callback
        })
    }
}
</script>
    
<style scoped>

</style>



// WEBPACK FOOTER //
// details.vue?9a979a6e